import React, { useState, useEffect } from 'react';
import './Transactions.scss';
import { Form, Select, DatePicker, Spin } from 'antd';
import columns from '../../../columns/transactions.jsx';
import ModalComponent from '../../../components/modals/ModalComponent.jsx';
import TableWithSkeleton from '../../../components/table/TableWithSkeleton.jsx';
import Pagination from '../../../components/pagination/Pagination.jsx';
import { useSelector } from 'react-redux';
import { GetTransactionsApi, GetUserScalpingDealsExcelApi } from '../../../api/request/transactions.js';
import Eye from '../../../assets/Eye.jsx';
import Download from '../../../assets/Download.jsx';
import moment from 'moment/moment.js';
import ReactPlayer from 'react-player'
import { GetAllTutorialsApi } from '../../../api/request/tutorials.js';
import Segmented from "../../../components/segmented/Segmented.jsx";
import { useSearchParams } from 'react-router-dom';
import ExportHandler from '../../../components/global/export/ExportHandler.jsx';
import { useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';

const { RangePicker } = DatePicker;

function ScalpingDownloadButton({ transactionId }) {
    const [isDownloading, setIsDownloading] = useState(false);

    const downloadScalpingRecord = async () => {
        try {
            setIsDownloading(true);
            const response = await GetUserScalpingDealsExcelApi(transactionId);
            const blob = new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `scalping-deals-${transactionId}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Failed to download scalping record');
        } finally {
            setIsDownloading(false);
        }
    };

    if (isDownloading) {
        return <Spin size="small" />;
    }

    return (
        <div
            className='cursor-pointer w-[22px] h-[22px]'
            title='Download scalping record'
            onClick={downloadScalpingRecord}
        >
            <Download color="var(--theme)" />
        </div>
    );
}

export default function Transactions() {
    const { userDetails } = useSelector(state => state.user);
    const [form] = Form.useForm();
    const [searchParams, setSearchParams] = useSearchParams();
    const [selectedTransaction, setSelectedTransaction] = useState({});
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [isOpenModalvideo, setIsOpenModalvideo] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalRecord, setTotalRecord] = useState(0);
    const [data, setData] = useState([]);
    const [tutorials, setTutorials] = useState();
    const [tutorialsdetails, setTutorialsdetails] = useState({});
    const [isOpenModaldetails, setIsOpenModaldetails] = useState(false);
    const [filter, setFilter] = useState('All');
    const location = useLocation();
    const [filterValue, setFilterValue] = useState('');
    const [dates, setDates] = useState([]);

    const options = ['All', 'Deposit', 'Withdrawal', 'Wallet To Account', 'Account To Wallet', 'IBWallet To Wallet'];

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const filter = searchParams.get('filter');
        if (filter) {
            setFilterValue(decodeURIComponent(filter));
        }
    }, [location.search]);

    const getTransactions = async () => {
        try {
            setIsLoading(true);
            let params = {
                PageNumber: page,
                PageSize: pageSize,
                FromDate: dates.length === 2 ? dates[0].format('MM-DD-YYYY') : '',
                ToDate: dates.length === 2 ? dates[1].format('MM-DD-YYYY') : '',
                FilterText: filterValue === "All"
                    ? " "
                    : filterValue === "Deposit"
                        ? "Deposit"
                        : filterValue === "Withdrawal"
                            ? "Withdrawal"
                            : filterValue === "Wallet To Account"
                                ? "WalletToAccount"
                                : filterValue === "Account To Wallet"
                                    ? "AccountToWallet"
                                    : filterValue === "IBWallet To Wallet"
                                        ? "IBWalletToWallet"
                                        : filterValue,
            }
            const { data } = await GetTransactionsApi(userDetails?._id, new URLSearchParams(params).toString());
            if (data?.success) {
                setData(
                    data?.data?.map((item) => {
                        return ({
                            ...item,
                            status: item?.status === "Success" ? (<span className='px-3 py-1 rounded-full uppercase text-xs text-center success_tag'>Success</span>) : (<span className='uppercase px-3 py-1 rounded-full text-xs text-center fail_tag'>Fail</span>),
                            actions: (
                                <div className='flex items-center gap-3'>
                                    <div className='cursor-pointer' onClick={() => { setSelectedTransaction(item); setIsOpenModal(true) }}>
                                        <Eye />
                                    </div>
                                    {item?.referenceId?.includes('Scalping profit deduction') && (
                                        <ScalpingDownloadButton transactionId={item?.transactionId} />
                                    )}
                                </div>
                            ),
                            transactionDate: item?.transactionDate ? moment(item?.transactionDate).format('DD-MM-YYYY LT') : null,
                            amount: `$ ${item?.amount}`
                        })
                    })
                );
                setTotalRecord(data?.totalRecords);
            }
            setIsLoading(false);
        } catch (error) {
            setData([]);
            setIsLoading(false);
        }
    }

    const getAllTutorials = async () => {
        try {
            setIsLoading(true);
            let params = {
                tutorialType: "Transactions"
            }
            const { data } = await GetAllTutorialsApi(new URLSearchParams(params).toString());
            if (data?.success) {
                setTutorials(data?.data);
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getTransactions();
    }, [page, pageSize, dates, filterValue]);

    useEffect(() => {
        if (searchParams?.get('filter')) {
            setFilter(searchParams?.get('filter'));
        };
        getAllTutorials()
    }, []);

    useEffect(() => {
        setSearchParams(`filter=${filter}`);
        form?.resetFields();
    }, [filter]);

    useEffect(() => {
        setPage(1);
    }, [dates]);
    const exportHandler = async () => {
        try {

            let params = {
                ApplyPagination: false,
                FromDate: dates && dates.length === 2 ? dates[0].format('MM-DD-YYYY') : '',
                ToDate: dates && dates.length === 2 ? dates[1].format('MM-DD-YYYY') : '',
                FilterText: filterValue === "All"
                    ? " "
                    : filterValue === "Deposit"
                        ? "Deposit"
                        : filterValue === "Withdrawal"
                            ? "Withdrawal"
                            : filterValue === "Wallet To Account"
                                ? "WalletToAccount"
                                : filterValue === "Account To Wallet"
                                    ? "AccountToWallet"
                                    : filterValue === "IBWallet To Wallet"
                                        ? "IBWalletToWallet"
                                        : filterValue,
            }
            const { data } = await GetTransactionsApi(userDetails?._id, new URLSearchParams(params).toString());
            if (data?.success) {
                return { data: data?.data, removableColumns: ['userId', 'transactionId'], fileName: 'Transactions' };
            } else {
                return { data: [], removableColumns: [] };
            }
        } catch (error) {
            return { data: [], removableColumns: [] };
        }
    };

    const addTutorialsModalHandler = (Item) => {
        setIsOpenModaldetails(true);
        setTutorialsdetails(Item)
    }


    return (
        <div className='transaction-container'>

            <div className='flex flex-wrap justify-between items-center sm:gap-5 gap-4'>
                <Select
                    className="min-w-44  ant-select-selector-white"
                    value={filter}
                    onChange={(value) => { setFilter(value); setPage(1); }}
                    options={options.map(option => ({ label: option, value: option }))}
                />
                {/* <Segmented options={['All', 'Deposit', 'Withdrawal', 'Wallet To Account', 'Account To Wallet', 'IBWallet To Wallet']} value={filter}
                    // setValue={setFilter}
                    setValue={(value) => {
                        setFilter(value);
                        setPage(1);
                    }}
                /> */}
                <div className='flex flex-wrap'>
                    <div className='mr-4'>
                        <div>
                            <RangePicker className='border-light border-2 w-full'
                                format='DD-MM-YYYY'
                                onChange={(selectedDates) => {
                                    setDates(selectedDates ? selectedDates : []);
                                }}
                            />
                        </div>
                    </div>
                    <div className='sm:mt-0 mt-4'>
                        <ExportHandler exportHandler={exportHandler} />
                    </div>
                </div>
            </div>

            <div className='w-full mt-8'>
                <div className='my-6'>
                    <div className="border border-gray-200 rounded-xl">
                        <TableWithSkeleton columns={columns} data={data} loading={isLoading} />
                    </div>
                    <Pagination total={totalRecord} page={page} setPage={setPage} pageSize={pageSize} setPageSize={setPageSize} />
                </div>
            </div>

            <ModalComponent isOpen={isOpenModal} setIsOpen={setIsOpenModal} title='Transaction Details' width={1000}>
                <div className='p-5'>
                    <div className='grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-10 '>
                        <div>
                            <p className='text-base font-normal '>Operation</p>
                            <p className='text-xl primary font-semibold mt-2'>{selectedTransaction?.operation}
                            </p>
                        </div>
                        <div>
                            <p className='text-base font-normal'>Payment From</p>
                            <p className='text-xl primary font-semibold mt-2'>{selectedTransaction?.paymentFrom}
                            </p>
                        </div>
                        <div>
                            <p className='text-base font-normal'>Payment To</p>
                            <p className='text-xl primary font-semibold mt-2'>{selectedTransaction?.paymentTo}</p>
                        </div>
                        <div>
                            <p className='text-base font-normal'>Amount</p>
                            <p className='text-xl primary font-semibold mt-2'>$ {selectedTransaction?.amount?.toFixed(2)}</p>
                        </div>
                        <div>
                            <p className='text-base font-normal pb-2'>Currency</p>
                            <p className='text-xl primary font-semibold mt-2'>{selectedTransaction?.currency}</p>
                        </div>
                        <div>
                            <p className='text-base font-normal'>Status</p>
                            <p className='text-xl primary font-semibold mt-2'>{selectedTransaction?.status}</p>
                        </div>
                        <div>
                            <p className='text-base font-normal'>Transaction Date</p>
                            <p className='text-xl primary font-semibold mt-2'>{moment(selectedTransaction?.transactionDate).format('DD-MM-YYYY')}</p>
                        </div>
                        <div>
                            <p className='text-base font-normal'>Transaction Code</p>
                            <p className='text-xl primary font-semibold mt-2'>
                                {selectedTransaction?.transactionCode}</p>
                        </div>
                        {selectedTransaction?.referenceId?.includes('Scalping profit deduction') && (
                            <div className='lg:col-span-4 md:col-span-3 sm:col-span-2'>
                                <p className='text-base font-normal'>Comment</p>
                                <p className='text-xl primary font-semibold mt-2 break-words'>
                                    {selectedTransaction?.referenceId}
                                </p>
                            </div>
                        )}
                    </div>
                </div>

            </ModalComponent>

            <ModalComponent isOpen={isOpenModalvideo} setIsOpen={setIsOpenModalvideo} title='Tutorial' width={1000}>
                {tutorials && tutorials.length > 0 ? (
                    <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-5 mt-6">
                        {tutorials.map((item, index) => (
                            <div
                                key={index}
                                className="shadow-lg cursor-pointer rounded-t-2xl overflow-hidden"
                                onClick={() => addTutorialsModalHandler(item)}
                            >
                                <div className="relative pb-[56.25%] h-0">
                                    {item.youtubeUrl ? (
                                        <ReactPlayer
                                            url={item.youtubeUrl}
                                            className="absolute top-0 left-0 w-full h-full"
                                            width="100%"
                                            height="100%"
                                            controls
                                        />
                                    ) : item.videoUrl ? (
                                        <ReactPlayer
                                            url={item.videoUrl}
                                            className="absolute top-0 left-0 w-full h-full"
                                            width="100%"
                                            height="100%"
                                            controls
                                        />
                                    ) : (
                                        <p>Video not available</p>
                                    )}
                                </div>
                                <div className="text-center p-4">
                                    <p className="text-lg font-semibold line-limit-1">{item.title}</p>
                                    <p className="text-[#7A7A7A] text-sm line-limit-2 mt-2">{item.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className='text-center'>
                        <p className='text-lg font-semibold'>Video not available</p>
                    </div>
                )}

            </ModalComponent>

            <ModalComponent isOpen={isOpenModaldetails} setIsOpen={setIsOpenModaldetails} title='Tutorial' width={800}>
                <div className="relative pb-[56.25%] h-0">

                    {tutorialsdetails.youtubeUrl ? (
                        <ReactPlayer
                            url={tutorialsdetails.youtubeUrl}
                            className="absolute top-0 left-0 w-full h-full"
                            width="100%"
                            height="100%"
                            controls
                        />
                    ) : tutorialsdetails.videoUrl ? (
                        <ReactPlayer
                            url={tutorialsdetails.videoUrl}
                            className="absolute top-0 left-0 w-full h-full"
                            width="100%"
                            height="100%"
                            controls
                        />
                    ) : (
                        <p>Video not available</p>
                    )}

                </div>
                <div className="text-center p-4">
                    <p className="text-lg font-semibold line-limit-1">{tutorialsdetails?.title}</p>
                    <p className="text-[#7A7A7A] text-sm line-limit-2 mt-2">{tutorialsdetails?.description}</p>
                </div>
            </ModalComponent>

        </div>
    )
}
